/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserTagsContainer_settings = {
    readonly " $fragmentRefs": FragmentRefs<"StaffTagContainer_settings">;
    readonly " $refType": "UserTagsContainer_settings";
};
export type UserTagsContainer_settings$data = UserTagsContainer_settings;
export type UserTagsContainer_settings$key = {
    readonly " $data"?: UserTagsContainer_settings$data;
    readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_settings">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserTagsContainer_settings",
    "selections": [
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "StaffTagContainer_settings"
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any);
(node as any).hash = 'c9ff24d0a5315803d81a7fbf762fde6e';
export default node;
